module.exports = __webpack_public_path__ + "static/sm-blog-darkmode-og-bcec5b009e1e4ff512b2f67ae102b590.jpg";